export function ShowPassword() {
  return (
    <svg width='18' height='12' viewBox='0 0 18 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 6C12 6.79565 11.6839 7.55871 11.1213 8.12132C10.5587 8.68393 9.79565 9 9 9C8.20435 9 7.44129 8.68393 6.87868 8.12132C6.31607 7.55871 6 6.79565 6 6C6 5.20435 6.31607 4.44129 6.87868 3.87868C7.44129 3.31607 8.20435 3 9 3C9.79565 3 10.5587 3.31607 11.1213 3.87868C11.6839 4.44129 12 5.20435 12 6ZM10.5 6C10.5 6.39782 10.342 6.77936 10.0607 7.06066C9.77936 7.34196 9.39782 7.5 9 7.5C8.60218 7.5 8.22064 7.34196 7.93934 7.06066C7.65804 6.77936 7.5 6.39782 7.5 6C7.5 5.60218 7.65804 5.22064 7.93934 4.93934C8.22064 4.65804 8.60218 4.5 9 4.5C9.39782 4.5 9.77936 4.65804 10.0607 4.93934C10.342 5.22064 10.5 5.60218 10.5 6Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18 6C18 9.5 13 12 9 12C5 12 0 9.5 0 6C0 2.5 5 0 9 0C13 0 18 2.5 18 6ZM16.5 6C16.5 6.983 15.78 8.084 14.221 9.03C12.705 9.95 10.724 10.5 9 10.5C7.275 10.5 5.295 9.95 3.778 9.03C2.22 8.084 1.5 6.983 1.5 6C1.5 5.017 2.22 3.916 3.778 2.97C5.295 2.05 7.275 1.5 9 1.5C10.724 1.5 12.705 2.05 14.221 2.97C15.781 3.916 16.5 5.017 16.5 6Z'
        fill='black'
      />
    </svg>
  );
}
